import React from 'react';
import Styles from './SuccessCoverage.module.scss';
import ToolTip from '../ToolTip/ToolTip';
import RichText from '../richtext';
import { replacePlaceholder } from '../../utils/utils';
import { deleteCookie } from 'cookies-next';
import { trackGADatalayerEvent } from '../../utils/AnalyticsUtils';
import { GAEVENT, SBLINECHECKCHANGE } from '../../Analytics/AnalyticsConstants';

const SuccessCoverage = ({
  content,
  data,
  lcData,
  setLcData,
  advData,
  desktopOverlay,
  mobileOverlay,
  handleModal,
  setAdvData,
  productName,
  lineCheckOnClear,
  onCreateCart,
  isModal,
  setShowModal,
  productId
}: any) => {
  const isAvailable =
    data?.eligibleBundle?.length != 0 && !productId
      ? true
      : data?.eligibleBundle?.length != 0 && productId && data?.eligibleBundle?.includes(productId)
      ? true
      : false;

  const EditButtonClick = () => {
    let coverageAddress = '';
    if (lcData?.addressList?.postCode && lcData?.addressList?.city) {
      coverageAddress = `${lcData?.addressList?.postCode}|${lcData?.addressList?.city}`;
    } else if (lcData?.selectedAddress) {
      const parts = lcData.selectedAddress.split(',');
      if (parts.length > 1) {
        const cityPart = parts[parts.length - 1].trim();
        const [zip, ...city] = cityPart.split(' ');
        coverageAddress = `${zip}|${city.join(' ')}`;
      }
    }

    const gaPayload: Record<string, any> = {
      component: 'Line Check',
      coverage_status: lcData?.linecheckResponse?.eligibleBundle?.length ? true : false,
      coverage_address: coverageAddress
    };

    if (lcData?.linecheckResponse?.lineCheckResponse?.eligibleAccess?.accessType) {
      gaPayload.coverage_type =
        lcData?.linecheckResponse?.lineCheckResponse?.eligibleAccess?.accessType;
    }
    if (
      lcData?.linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthDown &&
      lcData?.linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthUp
    ) {
      gaPayload.coverage_speed = `${lcData?.linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthDown}|${lcData?.linecheckResponse?.maxUploadDownloadSpeed?.maxBandwidthUp}`;
    }
    if (lcData?.plannedUpgrade) {
      gaPayload.planned_upgrade = lcData?.plannedUpgrade;
    }

    trackGADatalayerEvent(GAEVENT, SBLINECHECKCHANGE, gaPayload);

    typeof window != 'undefined' && localStorage.removeItem('lineCheckResponse');
    typeof window != 'undefined' && localStorage.removeItem('lineCheckRepsonse');
    typeof window != 'undefined' && localStorage.removeItem('one-commerce-access-type');
    typeof window != 'undefined' && localStorage.removeItem('one-commerce-linecheckcorrelationid');
    deleteCookie('chAddressJson');
    deleteCookie('one-commerce-linecheckcorrelationid');

    if (lcData?.adv) {
      setAdvData({
        ...advData,
        advOpen: lcData?.adv
      });
    } else {
      setAdvData({
        ...advData,
        advAddress: {},
        openOverlay: isModal ? true : advData?.openOverlay,
        advOpen: lcData?.adv
      });
    }

    setLcData({
      ...lcData,
      linecheckResponse: {},
      selectedAddress: '',
      apiError: false,
      adv: false
    });

    !lcData?.adv && typeof lineCheckOnClear === 'function' && lineCheckOnClear();
  };
  // Button for change address
  const btn = (
    <span className='changeBtn' onClick={EditButtonClick}>
      <span className={Styles.changeTxts}>{content?.changeAddBtn}</span>
    </span>
  );
  const adv = lcData?.adv;
  const handleModalClose = () => {
    if (isModal && typeof setShowModal === 'function') setShowModal();
    if (mobileOverlay) {
      setAdvData({ ...advData, openOverlay: false, advOpen: false });
    } else {
      handleModal();
    }
  };

  const createCart = () => {
    typeof onCreateCart === 'function' && onCreateCart();
  };

  return (
    <>
      <div
        className={
          desktopOverlay || mobileOverlay || isModal
            ? Styles['successmainContaineroverlay']
            : Styles['successmainContainer']
        }
      >
        {(data?.eligibleBundle != undefined || advData?.advAddress != '') && (
          <div
            className={`row d-flex col-sm-8 col-md-8 col-lg-8 mx-auto ${Styles.SuccessContainer}`}
          >
            <div className={Styles.successTitleIcon}>
              <div
                className={
                  desktopOverlay || mobileOverlay || isModal ? Styles['close-icon-wrapper'] : ''
                }
              >
                {(content?.addNotFoundIcon?.filename ||
                  content?.successIcon?.filename ||
                  content?.notAvailableIcon?.filename) && (
                  <img
                    src={
                      adv
                        ? content?.addNotFoundIcon?.filename
                        : isAvailable
                        ? content?.successIcon?.filename
                        : content?.notAvailableIcon?.filename
                    }
                    height={32}
                    width={32}
                    alt='LineCheck icon'
                  />
                )}
                {(desktopOverlay || mobileOverlay || isModal) && content?.closeIcon?.filename && (
                  <div className={Styles['close-iconn']} onClick={handleModalClose}>
                    <img
                      src={content?.closeIcon?.filename}
                      height={14}
                      width={14}
                      alt='cross-icon'
                    />
                  </div>
                )}
              </div>
              {(content?.advanceSearchErrorTitle ||
                content?.successTitle ||
                content?.notCoveredTxt) && (
                <h4 className={Styles.successTitle}>
                  {adv
                    ? content?.advanceSearchErrorTitle
                    : isAvailable
                    ? (desktopOverlay || mobileOverlay || isModal) && productName
                      ? replacePlaceholder(content?.overlaySuccessTitle, [productName])
                      : content?.successTitle
                    : (desktopOverlay || mobileOverlay || isModal) && productName
                    ? replacePlaceholder(content?.overlayNotAvailableTitle, [productName])
                    : content?.notCoveredTxt}
                </h4>
              )}
              {/* To be uncommented once condition for show updgrade message is decided */}
              {/* {content?.successSubtitle && isAvailable && (
                <p className={Styles.successSubtitle}>{content?.successSubtitle}</p>
              )} */}

              {content?.notCoveredSubtitle && !isAvailable && (
                <p className={Styles.successSubtitle}>{content?.notCoveredSubtitle}</p>
              )}

              {adv && content?.advanceSearchErrDescription && (
                <div className={Styles.advErrDesc}>
                  <RichText content={content?.advanceSearchErrDescription} />
                </div>
              )}
            </div>
            <div
              className={`${isAvailable ? Styles['coverageContainer'] : Styles['errorContainer']}`}
            >
              {isAvailable && !adv && (
                <>
                  <div className={Styles.speedSection}>
                    {content?.speedTxt && (
                      <div className={Styles.speedTxt}>
                        {content?.speedTxt}
                        <ToolTip content={content?.toolTipTxt} tooltipClass={Styles.toolTip} />
                      </div>
                    )}
                    <div className={Styles.uploadAndDownload}>
                      <div className={Styles.uploadSection}>
                        <div className={Styles.iconAndText}>
                          {content?.downloadIcon?.filename && (
                            <img
                              src={content?.downloadIcon?.filename}
                              height={15}
                              width={15}
                              alt='download Icon'
                            />
                          )}
                          {content?.downloadTxt && (
                            <div className={Styles.speedTxt}>{content?.downloadTxt}</div>
                          )}
                        </div>
                        {data?.maxUploadDownloadSpeed?.maxBandwidthDown && (
                          <div className={Styles.downloadTxt}>
                            {data?.maxUploadDownloadSpeed?.maxBandwidthDown}
                          </div>
                        )}
                      </div>
                      {!adv && (
                        <div className={Styles.separator} style={{ height: '64px' }}>
                          <div className={Styles.verticalLine}></div>
                        </div>
                      )}
                      <div className={Styles.uploadSection}>
                        <div className={Styles.iconAndText}>
                          {content?.uploadIcon?.filename && (
                            <img
                              src={content?.uploadIcon?.filename}
                              height={15}
                              width={15}
                              alt='upload Icon'
                            />
                          )}
                          {content?.uploadTxt && (
                            <div className={Styles.speedTxt}>{content?.uploadTxt}</div>
                          )}
                        </div>
                        {data?.maxUploadDownloadSpeed?.maxBandwidthUp && (
                          <div className={Styles.downloadTxt}>
                            {data?.maxUploadDownloadSpeed?.maxBandwidthUp}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={`${Styles.separator} ${Styles.mobileseparator}`}>
                    <div className={Styles.verticalLine}></div>
                  </div>
                </>
              )}

              <div className={Styles.addressSection}>
                <div className={Styles.addressContent}>
                  <div className={Styles.addressTitle}>{content?.addressTitle}</div>
                  <div className={Styles.addressDesc}>
                    {advData?.advAddress?.concatedAddress ?? lcData?.selectedAddress}
                  </div>
                </div>
                {content?.changeAddBtn && btn}
              </div>
            </div>
            {(desktopOverlay || mobileOverlay || isModal) &&
              isAvailable &&
              !adv &&
              content?.checkoutBtn &&
              productName && (
                <div className={`${Styles['ovelaybutton']}`}>
                  <button
                    name='check address button'
                    type='button'
                    className={`primarybutton`}
                    disabled={false}
                    onClick={createCart}
                  >
                    {content?.checkoutBtn}
                  </button>
                </div>
              )}
          </div>
        )}
      </div>
    </>
  );
};

export default SuccessCoverage;
